<div class="logged-in-view h-full overflow-y-auto">
    <div class="w-full">
        <h1 class="text-app-primary-10 mb-18">Termin vereinbaren</h1>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 text-app-primary-20">
            @for (doctor of doctorList; track doctor.id) {
                <div class="p-8 bg-white shadow-md rounded-button border border-app-primary-10">
                    <div class="font-semibold">
                        {{doctor.title ? doctor.title + ' ': ''}}{{doctor.firstName}} {{doctor.lastName}}
                    </div>
                    <div class="practice flex flex-col mt-4">
                        <div class="text-sm font-light">{{doctor.practice.name}}</div>
                        <div class="text-sm font-light">{{doctor.practice.address.street}} {{doctor.practice.address.houseNumber}}</div>
                        <div class="text-sm font-light">{{doctor.practice.address.zipCode}} {{doctor.practice.address.city}}</div>
                    </div>
                    <div class="practice flex flex-col mt-6">
                        <div class="text-sm font-semibold mb-2">Voraussichtliche Kosten</div>
                        <div class="grid grid-cols-1 2xl:grid-cols-2">
                            <span class="text-sm">Termin:</span>
                            <span class="text-sm">{{doctor.costs.treatmentCosts | number: '1.2-2'}} €</span>
                            <span class="text-sm">Rezeptausstellung:</span>
                            <span class="text-sm">{{doctor.costs.prescriptionCosts | number: '1.2-2'}} €</span>
                            <span class="text-sm">Rezeptversand:</span>
                            <span class="text-sm">{{doctor.costs.shippingCostsForPrescription | number: '1.2-2'}} €</span>
                        </div>

                    </div>
                    <div class="tile-content grid grid-cols-2 gap-4 pt-8">
                        <div class="col-span-2 text-sm">
                            Die Kosten können je nach ausgewählter Apotheke variieren.
                        </div>
                        <div class="col-span-2 text-sm">
                            Zusätzliche können Kosten für Medikamente und Versand entstehen.
                        </div>
                        <div class="col-span-2 text-sm">
                            Medikamentenversand kostenfrei ab 400€ Bestellwert.
                        </div>

                    </div>
                    <button class="btn primary-button w-full mt-4" (click)="selectDoctor(doctor)">
                        Jetzt Termin vereinbaren
                    </button>
                </div>
            }
        </div>
    </div>
</div>
